import { Mail, Phone, MapPin } from 'lucide-react';

export default function Contact() {
  return (
    <div className="container-x py-20 max-w-3xl">
      <span className="eyebrow">Get in touch</span>
      <h1 className="h-display text-4xl md:text-5xl mt-4">Contact IJE HAUS.</h1>
      <p className="sans text-base text-neutral-600 mt-4 max-w-xl leading-relaxed">
        For wholesale inquiries, order questions, or partnership opportunities, reach out via one of the
        channels below. New accounts should apply through the application form.
      </p>
      <div className="mt-14 grid md:grid-cols-3 gap-8">
        <div className="border border-neutral-200 p-6">
          <Mail size={22} strokeWidth={1.4} style={{ color: 'var(--ije-pink)' }} />
          <p className="eyebrow mt-4">Email</p>
          <a href="mailto:priscila@ijehaus.com" className="serif text-lg italic block mt-2 link-pink">priscila@ijehaus.com</a>
        </div>
        <div className="border border-neutral-200 p-6">
          <Phone size={22} strokeWidth={1.4} style={{ color: 'var(--ije-pink)' }} />
          <p className="eyebrow mt-4">Phone</p>
          <p className="serif text-lg italic mt-2">By appointment</p>
        </div>
        <div className="border border-neutral-200 p-6">
          <MapPin size={22} strokeWidth={1.4} style={{ color: 'var(--ije-pink)' }} />
          <p className="eyebrow mt-4">Address</p>
          <p className="serif text-lg italic mt-2">United States</p>
        </div>
      </div>
    </div>
  );
}
